'use strict';//Indicating browser should run only in java script mode

var EMROtherDomains = angular.module('EMR.OtherDomains', [])